import api from './../api'

export default {


	/**
	 * Load posts elements
	 */
	getTaxonomy({ commit }, taxonomy = 'category') {
        if(!taxonomy) return false;

        return api.getTaxonomy({taxonomy}).then(res=>{
            if(!res.data[0]) console.warn('taxonomy not found, by path', taxonomy)
            commit('STORE_TAXONOMY_DATA', {data: res.data, taxonomy: taxonomy});
            return res
        })
        
    },
    /**
     *  Load Related by meta posts
    */

    getMetaRelated({ commit }, data) {
        if(data && typeof (data) === "object"){
            if(!data.type) data.type == 'professions'
            if(!data.meta) data.meta == 'related_educations'
            if(!data.value) data.value == '1'
            return api.getMetaRelated(data).then(res=>{
                if(!res.data.posts[0] && (process.env.NODE_ENV === 'development')) console.warn('post not found')
                commit('STORE_PAGE_DATA', res.data.posts);
                return res
            })

        }else{
            console.error('Something went wrong in getMetaRelated')
            return null;   
        }

    },

    
    /**
	 * Load posts elements
	 */
	getPost({ commit, getters }, data) {
        const router = getters.getCurrentRoute;
        if(data && typeof (data) === "object"){
            if(!data.type) data.type == 'post'
            return api.getPost(data).then(res=>{
                if(!res.data.posts[0] && (process.env.NODE_ENV === 'development')) console.warn('post not found')
                commit('STORE_PAGE_DATA', res.data.posts);
                return res
            })
        }else if(router){
            const type = (router.meta.type === 'archive') ? 'page' : router.meta.post_type
            const slug = router.params.name
            const id = (!slug) ? router.meta.id : ''

            if(!slug && !id) return false;
  
            return api.getPost({type , slug, id}).then(res=>{
                if(!res.data.posts[0]) console.warn('post not found, by path')
                commit('STORE_PAGE_DATA', res.data.posts);
                return res
            })
        }else{
            console.error('Something went wrong in getPost')
            return null;
        }
    },

    loadMenu({commit}, location){
        return api.getMenu(location).then(res=>{
            if(!res.data) console.warn('menu not found', location)
            commit('STORE_PAGE_MENU', res.data);
            return res.data
        })
    }

}